import { inject, Injectable } from '@angular/core';
import { CommonService } from '../common.service';
import { Observable } from 'rxjs';
import {
  TaxonomyRequest,
  TaxonomyResponse,
  TaxonomyCreateRequest,
  TaxonomyDeleteRequest,
  EntityUpdateRequest,
  TaxonomyUpdateRequest,
  TaxonomyPublishRequest,
  TaxonomyReleaseForReviewRequest,
  TaxonomyGetByIDRequest,
  GenerateInsightsRequest,
  GetInsightsRequest,
  RerunTestRequest,
  DeleteTestRequest,
} from '../../pages/taxonomy-dashboard-v2/taxonomy.model';

@Injectable({
  providedIn: 'root',
})
export class TaxonomyApiService {
  public commonService = inject(CommonService);

  taxonomyPutBody = [];

  constructor() {}

  updateTaxonomy(body: TaxonomyRequest, id: string): Observable<any> {
    return this.commonService.postRequest(`taxonomy/update-item?uuid=${id}`, body);
  }

  deleteTaxonomy(body: { id: string }): Observable<any> {
    return this.commonService.postRequest(`taxonomy/delete-item?uuid=${body.id}`, body);
  }

  // TAXONOMY VERSION 2 - API CALLS - CRUD TAXONOMY

  createTaxomonyV2(body: TaxonomyCreateRequest): Observable<any> {
    return this.commonService.postRequest('user/create-taxonomy', body);
  }

  getTaxonomyV2(body: any): Observable<TaxonomyResponse> {
    return this.commonService.postRequest('user/get-all-taxonomies', body);
  }

  deleteTaxonomyV2(body: TaxonomyDeleteRequest): Observable<any> {
    return this.commonService.postRequest('user/delete-taxonomy', body);
  }

  getEntitiesV2ByTaxonomyId(body: any): Observable<any> {
    return this.commonService.postRequest('user/get-all-entities', body);
  }

  getSpecificTaxonomyV2ById(body: any): Observable<any> {
    return this.commonService.postRequest('user/get-taxonomy-by-id', body);
  }

  updateTaxonomyV2(body: any): Observable<TaxonomyUpdateRequest> {
    return this.commonService.postRequest('user/update-taxonomy', body);
  }

  publishTaxonomyV2(body: any): Observable<TaxonomyPublishRequest> {
    return this.commonService.postRequest('user/publish-taxonomy', body);
  }

  getVersionHistoryById(body: any): Observable<TaxonomyGetByIDRequest> {
    return this.commonService.postRequest('user/get-version-history', body);
  }

  releaseForReviewTaxonomy(body: any): Observable<TaxonomyReleaseForReviewRequest> {
    return this.commonService.postRequest('user/release-for-review', body);
  }

  //TAXONOMY VERSION 2 - API CALLS - CRUD ENTITIES

  addEntityV2(body: TaxonomyRequest): Observable<any> {
    return this.commonService.postRequest('user/create-entity', body);
  }

  updateEntityV2(body: EntityUpdateRequest): Observable<any> {
    return this.commonService.postRequest('user/update-entity', body);
  }

  deleteEntityV2(body: { id: string }): Observable<any> {
    return this.commonService.postRequest('user/delete-entity', body);
  }

  getEnitityByIdV2(body: { entity_id: string; taxonomy_id: string }) {
    return this.commonService.postRequest('user/get-entity-by-id', body);
  }

  // GENERAL SETTING SECTION

  getListOfQueueGroups(body: {}) {
    return this.commonService.postRequest('user/get-queue-groups', body);
  }

  // TAXONOMY PLAYGROUND APIs

  generateInsights(body: any): Observable<GenerateInsightsRequest> {
    return this.commonService.postRequest('taxonomy-playground/generate-insights', body);
  }

  getInsights(body: any): Observable<GetInsightsRequest> {
    return this.commonService.postRequest('taxonomy-playground/get-insights', body);
  }

  // CREATE DRAFT API
  createDraft(body: any): Observable<any> {
    return this.commonService.postRequest('user/create-draft', body);
  }

  // Taxonomy name check
  getExistingTaxonomyNames(body: {}) {
    return this.commonService.postRequest('user/get-existing-taxonomy-names', body);
  }

  // Clone taxonomy
  cloneTaxonomy(body: { taxonomy_id: string; version_id: string; taxonomy_name: string; taxonomy_description: string }): Observable<any> {
    return this.commonService.postRequest('user/clone-taxonomy', body);
  }

  // Create dataset
  createDataset(body: { label: string; description: string; contactIds: string[] }): Observable<any> {
    return this.commonService.postRequest('user/create-dataset', body);
  }

  // Get user dataset labels
  getUserDatasetLabels(): Observable<any> {
    return this.commonService.postRequest('user/get-user-datasets-labels', {});
  }

  // Get datasets by user
  getDatasetsByUser(): Observable<any> {
    return this.commonService.postRequest('user/get-datasets-by-user', {});
  }

  // Create test in taxonomy playground
  createTest(body: {
    taxonomy_id: string;
    record_id: string;
    label: string;
    dataset_id: string;
  }): Observable<any> {
    return this.commonService.postRequest('taxonomy-playground/create-test', body);
  }

  // Check if user can create a test
  canCreateTest(): Observable<any> {
    return this.commonService.postRequest('taxonomy-playground/can-create-test', {});
  }

  // Rerun test in taxonomy playground
  rerunTest(body: RerunTestRequest): Observable<any> {
    return this.commonService.postRequest('taxonomy-playground/rerun-test', body);
  }

  // Delete test in taxonomy playground
  deleteTest(body: DeleteTestRequest): Observable<any> {
    return this.commonService.postRequest('taxonomy-playground/delete-test', body);
  }

  // Get test result in taxonomy playground
  getTestResult(body: { batch_id: string }): Observable<any> {
    return this.commonService.postRequest('taxonomy-playground/get-test-result', body);
  }
}
